/* eslint-disable object-shorthand */
/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable no-var */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
'use strict';

var $ = require('jquery');
var ajax = require('../../utils/ajax');
var progress = require('../../utils/progress');
var util = require('../../utils/util');
var uniform = require('../../components/uniform');
var pdpSize = require('../../components/product/pdpsize');
var inputFields = require('../../utils/inputfields');
var validator = require('../../utils/validator');
var productSizeUtil = require('../../components/product/productsizeutil');
const flyinLoginForm = require('../../flyins/flyinLoginForm');

import wishlist from '../../pages/wishlist';
import {renderRecommendations} from '../../constructor-io/helpers/recommendations';

const friendlyCaptcha = require('../../widgets/friendlyCaptcha');

var findInsiders = function (elem) {
    var tabbable = elem.find('select, input, textarea, button, a, [role="button"]');

    if (tabbable.length === 0) {
        elem.on('keydown', function (e) {
            if (e.which === 9) {
                e.preventDefault();
            }
        });
    } else {
        var firstTabbable = tabbable.first();
        var lastTabbable = tabbable.last();
        /* set focus on first input */
        firstTabbable.focus();

        /* redirect last tab to first input */
        lastTabbable.on('keydown', function (e) {
            if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();
                firstTabbable.focus();
            }
        });

        /* redirect first shift+tab to last input */
        firstTabbable.on('keydown', function (e) {
            if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                lastTabbable.focus();
            }
        });
    }
};

var availabilityReminder = {
    init: function (options) {
        this.options = options || {};
        var $reminderLink = $('.product-reminder-trigger a');
        var $attributes = $('li.attribute');

        if (!$reminderLink.hasClass('availability-reminder-disabled')) {
            $attributes.each(function () {
                if ($(this).find('li.unselectable').length) {
                    $reminderLink.css('visibility', 'visible');

                    if ($(this).find('li.unselectable a.swatchanchor').attr('aria-checked') === 'true') {
                        $('#add-to-cart').addClass('disabled-btn').attr('aria-disabled', true);
                        $('#apple-pay-pdp-button').addClass('apple-pay-hidden');
                    }
                }
            });
        }
    },

    initFlyIn: async function ($reminderFlyInContainer) {
        $reminderFlyInContainer.off('submit', '.flyout-ajax-login');
        if ($reminderFlyInContainer.find('.flyout-ajax-login').length > 0) {
            flyinLoginForm.initLoginFormEvents($reminderFlyInContainer, 'signInForAvailabilityReminder');
            return;
        }
        sessionStorage.removeItem('signInForAvailabilityReminder');

        var $reminderFlyIn = $reminderFlyInContainer.find('.availability-reminder');
        var $reminderForm = $reminderFlyInContainer.find('form');

        var isConstructorRecomm = $reminderFlyInContainer.find('.js-add-to-cart-recomm-constructor').length > 0;

        if (isConstructorRecomm) {
            var data = $reminderFlyInContainer.find('.js-parent-product').data();
            let parentProductId = data.parentProductId;
            await renderRecommendations('availability-reminder', [parentProductId]);
        }

        wishlist.init();

        function checkComplete() {
            var selectionComplete = true;
            $reminderFlyIn.find('li.attribute').each(function () {
                if (!$(this).find('li.selected').length) {
                    selectionComplete = false;
                }
            });

            if (selectionComplete) {
                setTimeout(function () {
                    $reminderForm.valid();
                }, 100);
            }
        }

        $reminderFlyIn.on('blur', 'input', checkComplete);
        $reminderFlyIn.on('input', 'input', function () {
            var $this = $(this);
            var $button = $reminderFlyIn.find('.send-button');

            if ($this.val() && $button.hasClass('button-disabled')) {
                $button.removeClass('button-disabled');
            } else if (!$this.val()) {
                $button.addClass('button-disabled');
            }
        });

        $reminderFlyInContainer.off('submit', '.flyout-ajax-login');
        this.initFormEvents($reminderFlyInContainer);
    },

    initFormEvents: function ($reminderFlyInContainer) {
        var $reminderFlyIn = $reminderFlyInContainer.find('.availability-reminder');
        var $reminderForm = $reminderFlyInContainer.find('form');
        var $attributes = $reminderFlyIn.find('li.attribute');
        var $emailField = $reminderFlyIn.find('.email-field');
        var selectionComplete = true;
        var formValidator;

        pdpSize.init('.fly-in-dialogue-avaliability .ocd-content');
        if (!('uniform' in (this.options || {})) || this.options.uniform !== false) {
            uniform();
        }
        inputFields.init();
        formValidator = validator.init();

        // only on submit form content
        if (!$reminderFlyIn.find('.availability-success').length && !$reminderFlyIn.find('.warning-form').length) {
            // enable button
            $attributes.each(function () {
                if (!$(this).find('li.selected').length) {
                    selectionComplete = false;
                }
            });

            // click on swatch - should replace reminder content with new variant
            $reminderFlyIn.find('.swatchanchor').on('click', function (e) {
                var href;

                if ($(this).closest('ul').hasClass('color') && !$(this).closest('.pdp-main').hasClass('quickview')) {
                    return;
                }

                e.preventDefault();
                if ($(this).parents('li').hasClass('unselectable') || $(this).parents('li').hasClass('selected')) {
                    return;
                }

                var email = $emailField.find('input').val();
                href = this.getAttribute('data-href') + '&email=' + encodeURIComponent(email);

                updateContent(href);
            });

            $reminderFlyIn.on(
                'click keypress',
                '.size-region a, .attribute.size .form-row-radio.region-select',
                function (e) {
                    if (util.isClickOrSpaceOrEnter(e)) {
                        productSizeUtil.changeSizeRegion(this);
                    }
                }
            );

            $reminderFlyIn
                .find('.availability-reminder-content .fly-in-link-store-inventory')
                .on('click', function (e) {
                    if ($(this).data('allow-master') !== 'true') {
                        var $reminderFlyIn = $('.fly-in-dialogue-avaliability .ocd-content');
                        var $attributes = $reminderFlyIn.find('li.attribute');
                        var selectionComplete = true;
                        $attributes.each(function () {
                            if (!$(this).find('li.selected').length) {
                                selectionComplete = false;
                                $(this).find('.label').addClass('reminder');
                                $(this).find('li').addClass('reminder');
                                $(this).find('.selection').addClass('reminder');
                                $(this).find('.attribute-dropdown').addClass('red-error');
                            }
                        });

                        if (!selectionComplete) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            return false;
                        }
                    }

                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'storeAvailabilityClickedRemindMe',
                            storeAvailabilityEan: $(this).data('product-id')
                        });
                    }
                });

            // handle submit action
            $reminderFlyIn.find('.send-button').on('click', function (e) {
                var url = $(this).closest('form').attr('action');
                e.preventDefault();

                $attributes.each(function () {
                    if (!$(this).find('li.selected').length) {
                        selectionComplete = false;
                        $(this).find('.label').addClass('reminder');
                        $(this).find('li').addClass('reminder');
                        $(this).find('.selection').addClass('reminder');
                        $(this).find('.attribute-dropdown').addClass('red-error');
                    }
                });

                $reminderFlyIn.find('.email-field .error-msg').remove();
                $emailField.removeClass('validation-error');
                formValidator.element('.availability-reminder .email');

                if ($emailField.find('.form-row').hasClass('validation-error')) {
                    $emailField.addClass('validation-error');
                }

                if (!selectionComplete) {
                    $reminderFlyIn.find('.send-button').addClass('button-disabled');
                    return;
                }

                if ($emailField.find('.form-row').hasClass('validation-error')) {
                    $reminderFlyIn.find('.send-button').addClass('button-disabled');
                    return;
                }

                $reminderFlyInContainer = $('.fly-in-dialogue-avaliability .ocd-content');
                progress.show($reminderFlyInContainer);

                $.ajax({
                    type: 'POST',
                    url: url,
                    data: $reminderForm.serialize()
                }).done(function (response) {
                    $reminderFlyInContainer.html(response);
                    availabilityReminder.initFlyIn($reminderFlyInContainer);
                    friendlyCaptcha.init('.nlsubscribe-form-flyin .frc-captcha');
                });
            });
        }

        $reminderFlyInContainer.trigger('flyin:initialized', {
            flyin: 'availibiltyReminder'
        });
    }
};

/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 */

var updateContent = function (href) {
    var params = {
        format: 'ajax',
        updateContent: true
    };

    var $close = $('.fly-in-dialogue-avaliability .ocd-content .ocd-close').detach();

    progress.show($('.fly-in-dialogue-avaliability .ocd-content'));

    if (href.indexOf('groupSize') < 0) {
        href += '&groupSize=' + $('#groupSize').val(); // eslint-disable-line no-param-reassign
    }

    ajax.load({
        url: util.appendParamsToUrl(href, params),
        target: $('.fly-in-dialogue-avaliability .ocd-content .availability-reminder-form'),
        callback: function () {
            var $flyin = $('.ocd-flyin');
            var $flyinContent = $('.fly-in-dialogue-avaliability .ocd-content');
            $flyinContent.append($close);
            availabilityReminder.initFormEvents($flyinContent);
            $('#groupSize').attr('value', util.getParameterByName('groupSize', href));
            findInsiders($flyin);
            var sendButton = $('button[name$="availabilityreminder_savereminder"]');
            var emailInput = $('input[name$="availabilityreminder_email"]');
            if (emailInput.val() && sendButton.hasClass('button-disabled')) {
                sendButton.removeClass('button-disabled');
            } else if (!emailInput.val()) {
                sendButton.addClass('button-disabled');
            }
        }
    });
};

module.exports = availabilityReminder;
